import { createContext } from 'react';
import type { User } from 'firebase/auth';
import type { Permission } from '@/config/permissions';
import type { UserProfile } from '@/types/user';

export type AuthContextValue = {
  firebaseUser: User | null;
  profile: UserProfile | null;
  loading: boolean;
  profileError: string | null;
  /** Acceso completo al ERP (activo y rol distinto de pending). */
  isAuthenticated: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signInWithGoogle: () => Promise<void>;
  signOut: () => Promise<void>;
  hasPermission: (permission: Permission) => boolean;
  refreshProfile: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
